import MainPanel from "./MainPanel";

export default MainPanel;
